<template>
	<section id="materials" class="bg-primary">
		<b-container fluid class="px-0">
			<b-row class="align-items-center">
				<b-col cols="12" lg="6" order="2" order-lg="1" class="text-center py-5 py-lg-4">
					<img src="../assets/img/icons/materials.svg" alt="Råvaror & jordbruk" width="175" height="175" class="img-fluid d-inline-block">
					<h2 class="text-beige text-uppercase font-weight-bold mb-md-0 mb-lg-2 py-3 pb-md-0 pb-lg-3">Råvaror <br>& jordbruk</h2>
					<hr class="border-secondary bold w-5 d-inline-block"/>
					<b-row>
						<b-col cols="12" lg="9" class="mx-auto px-5 px-lg-4 rem-max-50">
							<p class="text-beige">Att få fram mat till allt fler utan att slita på planeten är en rejäl utmaning. Ingen fixar det på egen hand – här krävs samarbete. Lidl bidrar bland annat genom ansvarsfulla inköp av kritiska råvaror, till exempel palmolja.</p>
							<a :href="$creo.browserPdfLink(pdfLink.org, pdfLink.fallback, pdfLink.page)" target="_blank" class="font-weight-bold text-beige m-0 pt-3 pt-md-0 pt-lg-3 text-center text-uppercase d-block">Läs mer</a>
						</b-col>
					</b-row>
				</b-col>
				<b-col cols="12" lg="6" order="1" order-lg="2" class="cover scroll materials mh-70 mh-md-65 mh-lg-60 mh-xl-45 mh-xxl-35">
					&nbsp;
				</b-col>
			</b-row>
		</b-container>
	</section>
</template>
<script>
	export default {
		name: 'Materials',
		props: {
			pdfLink: {
				default: null
			}
		}
	}
</script>
